var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-static-modal"},[_c('div',{staticClass:"full-screen-fader flex-column justify-content-center"},[_c('div',{staticClass:"utlz-container"},[_c('div',{staticClass:"utlz-row"},[_c('div',{staticClass:"utlz-col-md-8 utlz-offset-md-2"},[_c('div',{staticClass:"modal-content"},[_vm._t("static-modal-content")],2)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }